/* Large screens - when width > 430px OR height > 932px, constrain and add border radius */
@media (min-width: 449px), (min-height: 933px) {
  #root-layout-container {
    max-width: 448px;
    max-height: 932px;
    border-radius: 16px; /* Theme borderRadius 'l' equivalent */
  }
} 
